import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const NonsmokingSpacesIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "NonsmokingSpacesIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M19.2513 4.92891C17.3625 3.0402 14.8513 2 12.1802 2C9.5091 2 6.99788 3.0402 5.10909 4.92891C3.22038 6.8177 2.18018 9.32892 2.18018 12C2.18018 14.6711 3.22038 17.1823 5.10909 19.0711C6.99788 20.9598 9.5091 22 12.1802 22C14.8513 22 17.3625 20.9598 19.2513 19.0711C21.14 17.1823 22.1802 14.6711 22.1802 12C22.1802 9.32892 21.14 6.8177 19.2513 4.92891ZM3.35205 12C3.35205 7.13215 7.31233 3.17187 12.1802 3.17187C14.4037 3.17187 16.4376 3.99851 17.9914 5.36015L13.1142 10.2373H6.29639C5.9728 10.2373 5.71045 10.4997 5.71045 10.8232V13.1768C5.71045 13.5004 5.97279 13.7627 6.29639 13.7627H9.58886L5.54034 17.8112C4.1787 16.2574 3.35205 14.2235 3.35205 12ZM13.9478 11.4092V12.5908H12.418L13.5996 11.4092H13.9478ZM11.9424 11.4092L10.7607 12.5908H6.88234V11.4092H11.9424ZM12.1802 20.8281C9.95667 20.8281 7.9228 20.0015 6.36897 18.6399L11.2461 13.7627H18.064C18.3876 13.7627 18.6499 13.5004 18.6499 13.1768V10.8232C18.6499 10.4997 18.3876 10.2373 18.064 10.2373H14.7715L18.82 6.18879C20.1817 7.74262 21.0083 9.77649 21.0083 12C21.0083 16.8679 17.048 20.8281 12.1802 20.8281ZM15.1196 12.5908V11.4092H17.478V12.5908H15.1196Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M7.47315 9.05567C7.79674 9.05567 8.05909 8.79333 8.05909 8.46973C8.05909 8.14395 8.32413 7.87891 8.64991 7.87891C9.62186 7.87891 10.4126 7.08817 10.4126 6.11621V5.7207C10.4126 5.39711 10.1503 5.13476 9.82667 5.13476C9.50307 5.13476 9.24073 5.3971 9.24073 5.7207V6.11621C9.24073 6.44199 8.97569 6.70703 8.64991 6.70703C7.67796 6.70703 6.88721 7.49777 6.88721 8.46973C6.88721 8.79332 7.14955 9.05567 7.47315 9.05567Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default NonsmokingSpacesIcon;
